import React from 'react';

import { useModal } from '~/features/modals/modal-actions';
import FunnelAuthModal from '~/components/modals/funnel-auth/funnel-auth-modal';
import ErrorModal from '~/components/modals/error-modal';
import LargeLawnModal from '~/components/modals/large-lawn/large-lawn-modal';
import GuaranteeModal from '~/components/modals/guarantee-modal';
import LawnMapModal from '~/components/modals/lawn-map/lawn-map-modal';
import UpdateShippingAddressModal from '~/components/modals/account-settings/update-shipping-address-modal';
import CreateShippingAddressModal from '~/components/modals/account-settings/create-shipping-address-modal';
import UpdatePasswordModal from '~/components/modals/account-settings/update-password-modal';
import UpdatePaymentModal from '~/components/modals/account-settings/update-payment-modal';
import AuthFailModal from '~/components/modals/account-settings/auth-fail-modal';
import UpdateNameModal from '~/components/modals/account-settings/update-name-modal';
import OfferRedeemedModal from '~/components/modals/cancellation/offer-redeemed-modal';
import ProductDetailModal from '~/components/modals/product-details/product-details-modal';
import SortModal from '~/components/modals/add-ons/sort-modal';
import ShedFiltersModal from '~/components/modals/shed-filters/shed-filters-modal';
import EarlyRenewalModal from './account-settings/early-renewal-modal';
import SoilTestModal from '~/components/modals/soil-test-modal';
import StoreAuthModal from '~/components/modals/store-auth/store-auth-modal';
import CartValidationModal from '~/components/modals/cart-validation-modal';
import AddedToCartModal from '~/components/modals/added-to-cart/added-to-cart-modal';
import SmallLawnModal from '~/components/modals/small-lawn/small-lawn-modal';
import SomethingsNotRightModal from '~/components/modals/somethings-not-right-modal';
import CheckoutConfirmationModal from '~/components/modals/checkout-confirmation/checkout-confirmation-modal';
import ForgotPasswordModal from '~/components/modals/funnel-auth/forgot-password-modal';
import PestBundleModal from '~/components/modals/pest-bundle/pest-bundle-modal';
import MagicLinkModal from '~/components/modals/magic-link/magic-link-modal';
import ConfirmModal from '~/components/modals/confirm-modal';
import PrivacyModal from '~/components/modals/privacy-modal';
import LiquidGranularInfoModal from '~/components/modals/liquid-granular-info/liquid-granular-info-modal';
import PlanFAQsModal from '~/components/modals/plan-faqs/plan-faqs-modal';
import TermsConditionsModal from '~/components/modals/terms-conditions/terms-conditions-modal';
import LawnSizeModal from '~/components/modals/lawn-size/lawn-size-modal';
import ShipNowModal from '~/components/modals/ship-now/ship-now-modal';
import SkipShipmentModal from '~/components/modals/skip-shipment/skip-shipment-modal';
import SkipShipmentConfirmationModal from '~/components/modals/skip-shipment/skip-shipment-confirmation-modal';
import GardenSizeInfoModal from '~/components/modals/garden-size-info/garden-size-info-modal';
import PestTypeModal from '~/components/modals/pest-type/pest-type-modal';
import EmailCaptureModal from '~/components/modals/email-capture/email-capture-modal';
import GrassTypeModal from '~/components/modals/grass-type/grass-type-modal';
import SmsSubscribeModal from '~/components/modals/sms/sms-subscribe-modal';
import SimpleTextModal from '~/components/modals/simple-text/simple-text-modal';
import LawnPlanReviewsModal from '~/components/modals/lawn-plan-reviews/lawn-plan-reviews-modal';
import PestTypeYardModal from '~/components/modals/pest-type/pest-type-yard-modal';
import BoxProductDetailsModal from '~/components/modals/account/boxes/box-product-details-modal';

const ModalSelector = () => {
  const { currentModal, modalData, hideModal } = useModal();

  return (
    <>
      <FunnelAuthModal
        onClose={() => {
          modalData.onClose && modalData.onClose();
          hideModal();
        }}
        isOpen={currentModal === 'FUNNEL_AUTH'}
        onAuth={modalData.onAuth}
        content={modalData.content}
        magicLinkRedirectUrl={modalData.magicLinkRedirectUrl}
        source={modalData.source}
        initialPage={modalData.initialPage}
      />
      <ErrorModal
        onClose={hideModal}
        isOpen={currentModal === 'ERROR'}
        {...modalData}
      />
      <LargeLawnModal
        isOpen={currentModal === 'LARGE_LAWN'}
        lawn={modalData.lawn}
        newLawnSize={modalData.newLawnSize}
        onContinue={modalData.onContinue}
        onClose={() => {
          if (modalData.onClose) {
            modalData.onClose();
          }

          hideModal();
        }}
      />
      <SmallLawnModal
        isOpen={currentModal === 'SMALL_LAWN'}
        lawn={modalData.lawn}
        newLawnSize={modalData.newLawnSize}
        onContinue={modalData.onContinue}
        onClose={() => {
          if (modalData.onClose) {
            modalData.onClose();
          }

          hideModal();
        }}
      />
      <GuaranteeModal
        onClose={hideModal}
        isOpen={currentModal === 'GUARANTEE'}
      />
      <LawnMapModal
        onClose={hideModal}
        isOpen={currentModal === 'LAWN_MAP'}
        src={modalData.src}
      />
      <CreateShippingAddressModal
        onClose={hideModal}
        isOpen={currentModal === 'CREATE_SHIPPING_ADDRESS'}
      />
      <UpdateShippingAddressModal
        onClose={hideModal}
        isOpen={currentModal === 'UPDATE_SHIPPING_ADDRESS'}
        addressUuid={modalData.addressUuid}
      />
      <UpdatePasswordModal
        onClose={hideModal}
        isOpen={currentModal === 'UPDATE_PASSWORD'}
        creationMethod={modalData.creationMethod}
      />
      <UpdatePaymentModal
        onClose={hideModal}
        isOpen={currentModal === 'UPDATE_PAYMENT'}
      />
      <AuthFailModal
        onClose={hideModal}
        isOpen={currentModal === 'AUTH_FAIL'}
        nextCommittedOrderUuid={modalData.nextCommittedOrderUuid}
        coupon={modalData.coupon}
        nextChargeDate={modalData.nextChargeDate}
        lawn={modalData.lawn}
      />
      <EarlyRenewalModal
        onClose={hideModal}
        isOpen={currentModal === 'EARLY_RENEWAL'}
        subscriptionUuid={modalData.subscriptionUuid}
      />
      <UpdateNameModal
        onClose={hideModal}
        isOpen={currentModal === 'UPDATE_NAME'}
      />
      <CheckoutConfirmationModal
        onClose={hideModal}
        isOpen={currentModal === 'CHECKOUT_CONFIRMATION'}
        cart={modalData.cart}
        creationMethod={modalData.creationMethod}
      />
      <OfferRedeemedModal
        content={modalData.content}
        isOpen={currentModal === 'OFFER_REDEEMED'}
        onClose={hideModal}
      />
      <ProductDetailModal
        channel={modalData.channel}
        isOpen={currentModal === 'PRODUCT_DETAIL'}
        onClose={hideModal}
        product={modalData.product}
        objectID={modalData.objectID}
        queryID={modalData.queryID}
        position={modalData.position}
        qtySelected={modalData.qtySelected}
        showViewDetailsLink={modalData.showViewDetailsLink}
        ctaButton={modalData.ctaButton}
        showAtc={modalData.showAtc}
        showPspCopy={modalData.showPspCopy}
      />
      <SortModal
        isOpen={currentModal === 'SORT_OPTIONS'}
        onClose={hideModal}
        onSelect={modalData.onSelect}
        selectedOption={modalData.selectedOption}
        sortOptions={modalData.sortOptions}
      />
      <ShedFiltersModal
        isOpen={currentModal === 'SHED_FILTERS'}
        onClose={hideModal}
      />
      <SoilTestModal
        isOpen={currentModal === 'SOIL_TEST'}
        onClose={hideModal}
        address={modalData.address}
      />
      <StoreAuthModal
        isOpen={currentModal === 'STORE_AUTH'}
        magicLinkRedirectUrl={modalData.magicLinkRedirectUrl}
        onAuth={modalData.onAuth}
        onClose={() => {
          modalData.onClose && modalData.onClose();
          hideModal();
        }}
        userAddress={modalData.address}
        type={modalData.type}
      />
      <CartValidationModal
        isOpen={currentModal === 'CART_VALIDATION'}
        onClose={hideModal}
        outOfStockSkus={modalData.outOfStockSkus}
        restrictedSkus={modalData.restrictedSkus}
      />
      <AddedToCartModal
        isOpen={currentModal === 'ADDED_TO_CART'}
        onClose={hideModal}
        product={modalData.product}
        recommendedProducts={modalData.recommendedProducts}
        showRecommendedProducts={modalData.showRecommendedProducts}
      />
      <SomethingsNotRightModal
        isOpen={currentModal === 'SOMETHINGS_NOT_RIGHT'}
        onClose={hideModal}
        route={modalData.route}
      />
      <ForgotPasswordModal
        isOpen={currentModal === 'FORGOT_PASSWORD'}
        onClose={hideModal}
        lawnUuid={modalData.lawnUuid}
      />
      <PestBundleModal
        isOpen={currentModal === 'PEST_BUNDLE'}
        onClose={hideModal}
        bundles={modalData.bundles}
        largePlan={modalData.largePlan}
        channel={modalData.channel}
      />
      <MagicLinkModal
        isOpen={currentModal === 'MAGIC_LINK'}
        magicLinkRedirectUrl={modalData.magicLinkRedirectUrl}
        onAuth={modalData.onAuth}
        onClose={() => {
          modalData.onClose && modalData.onClose();
          hideModal();
        }}
      />
      <ConfirmModal
        isOpen={currentModal === 'CONFIRM'}
        onClose={hideModal}
        {...modalData}
      />
      <PrivacyModal isOpen={currentModal === 'PRIVACY'} onClose={hideModal} />
      <LiquidGranularInfoModal
        isOpen={currentModal === 'LIQUID_GRANULAR'}
        onClose={hideModal}
      />
      <PlanFAQsModal
        isOpen={currentModal === 'PLAN_FAQS'}
        onClose={hideModal}
        initialQuestion={modalData.question}
        faqContent={modalData.faqContent}
      />
      <TermsConditionsModal
        isOpen={currentModal === 'TERMS_CONDITIONS'}
        onClose={hideModal}
        content={modalData.content}
      />
      <LawnSizeModal
        isOpen={currentModal === 'LAWN_SIZE'}
        onClose={hideModal}
        lawn={modalData.lawn}
        isDryFert={modalData.isDryFert}
      />
      <ShipNowModal
        isOpen={currentModal === 'SHIP_NOW'}
        onClose={hideModal}
        shipment={modalData.shipment}
        order={modalData.order}
      />
      <SkipShipmentModal
        isOpen={currentModal === 'SKIP_SHIPMENT'}
        onClose={hideModal}
        isFlexPay={modalData.isFlexPay}
        cartUuid={modalData.cartUuid}
        shipmentNumber={modalData.shipmentNumber}
        shipmentDate={modalData.shipmentDate}
      />
      <SkipShipmentConfirmationModal
        isOpen={currentModal === 'SKIP_SHIPMENT_CONFIRMATION'}
        onClose={hideModal}
        isFlexPay={modalData.isFlexPay}
        shipmentNumber={modalData.shipmentNumber}
        storeCreditValue={modalData.storeCreditValue}
        shipmentDate={modalData.shipmentDate}
      />
      <GardenSizeInfoModal
        isOpen={currentModal === 'GARDEN_SIZE'}
        onClose={hideModal}
      />
      <PestTypeModal
        isOpen={currentModal === 'PEST_TYPE'}
        onClose={hideModal}
      />
      <PestTypeYardModal
        isOpen={currentModal === 'PEST_TYPE_YARD'}
        onClose={hideModal}
      />
      <EmailCaptureModal
        isOpen={currentModal === 'EMAIL_CAPTURE'}
        onClose={hideModal}
        status={modalData.status}
      />
      <GrassTypeModal
        isOpen={currentModal === 'GRASS_TYPE'}
        onClose={hideModal}
      />
      <SmsSubscribeModal
        isOpen={currentModal === 'SMS_SUBSCRIBE'}
        onClose={hideModal}
        defaultShippingAddress={modalData.defaultShippingAddress}
      />
      <SimpleTextModal
        isOpen={currentModal === 'SIMPLE_TEXT'}
        onClose={hideModal}
        content={modalData.content}
      />
      <LawnPlanReviewsModal
        isOpen={currentModal === 'LAWN_PLAN_REVIEWS'}
        onClose={hideModal}
      />
      <BoxProductDetailsModal
        isOpen={currentModal === 'BOX_PRODUCT_DETAILS'}
        onClose={hideModal}
        skuId={modalData.skuId}
        quantity={modalData.quantity}
        product={modalData.product}
        cartUuid={modalData.cartUuid}
        shippingAddressState={modalData.shippingAddressState}
      />
    </>
  );
};

export default ModalSelector;
